import {
  AlertOctagonIcon,
  AlertTriangleIcon,
  CheckCircleIcon,
  InfoIcon,
} from 'components/shared/Icon/Icon'

const MEDIUM = 'medium'
const SMALL = 'small'

const ERROR = 'error'
const INFO = 'info'
const SUCCESS = 'success'
const WARNING = 'warning'

export type AlertSize = typeof MEDIUM | typeof SMALL
export type AlertVariant =
  typeof ERROR | typeof INFO | typeof SUCCESS | typeof WARNING

export const SIZES = {
  MEDIUM,
  SMALL,
}

export const VARIANTS = {
  ERROR,
  INFO,
  SUCCESS,
  WARNING,
}

export const ICONS = {
  [ERROR]: AlertOctagonIcon,
  [INFO]: InfoIcon,
  [SUCCESS]: CheckCircleIcon,
  [WARNING]: AlertTriangleIcon,
}
